<template>
  <div class="main">
    <PromptModal ref="kubaoLotteryPrompt" :url="user.kubaoLotteryLoginUrl" />

    <div class="top-wrap">
      <div
        class="avatar"
        :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
      ></div>

      <div class="info">
        <div class="text text-1">{{ user.nickname }}</div>
        <div class="text text-2">会员ID：{{ user.memberId }}</div>
      </div>
      <div class="bg"></div>
    </div>

    <div class="menu-list">
      <!-- 大玩家用户隐藏 -->
      <template v-if="!easyUser">
        <menu-item class="first-menu-item" type="custom">
          <div class="point-box">
            <div class="menu-point">{{ user.point }} {{ user.pointUnit }}</div>
            <div class="point-title">我的积分</div>
          </div>
          <!-- 账户余额：<span class="menu-point">{{user.point}} {{user.pointUnit}}</span> -->

          <template v-if="user.kkbUser && user.kubaoLotteryLoginUrl">
            <a class="menu-btn" @click="goToKubaoLottery">赢取积分</a>
          </template>
          <template v-else>
            <router-link class="menu-btn" to="/pages/products/List"
              >去使用</router-link
            >
          </template>
        </menu-item>
      </template>

      <div class="menu-center">
        <MenuItem
          :class="{ 'first-menu-item': easyUser }"
          type="link"
          text="订单管理"
          link="/pages/orders/list"
          :img="require('../../assets/ddgl_icon.png')"
        />

        <!-- 大玩家用户隐藏 -->
        <template v-if="!easyUser">
          <MenuItem
            type="link"
            text="我的卡包"
            link="/pages/orders/Wallet"
            :img="require('../../assets/wdkabao_icon.png')"
          />
        </template>

        <!-- 大玩家用户隐藏 -->
        <template v-if="!easyUser">
          <MenuItem
            type="link"
            text="地址管理"
            link="/pages/setting/AddressList"
            :img="require('../../assets/dzgl_icon.png')"
          />
        </template>

        <!-- 大玩家用户隐藏 -->
        <template v-if="!easyUser">
          <MenuItem
            type="link"
            text="兑换明细"
            :link="user.pointDetailPageUrl"
            v-if="user.pointDetailPageUrl"
            :img="require('../../assets/duimmxi_icon.png')"
          />
        </template>

        <!-- 大玩家用户隐藏 -->
        <template v-if="!easyUser && active">
          <MenuItem
            type="link"
            text="积分小游戏"
            v-if="user.enableLottery"
            @click.native="gotoLottery"
            :img="require('../../assets/xiaoyouxi_icon.png')"
          />
        </template>
      </div>

      <!-- <MenuItem type="link" text="手机号码" link="/pages/setting/Phones"/> -->
    </div>
    <!-- <p class="display-id">{{user.displayId}}</p> -->
    <TabBar active="setting"></TabBar>
  </div>
</template>

<script>
import api from "../../api";
import store from "../../api/store";
import MenuItem from "@/components/setting/MenuItem";
import PromptModal from "@/components/kubaolottery/PromptModal";

export default {
  title: "我的",
  bodyClass: "gray-bg",
  components: { MenuItem, PromptModal },
  data() {
    return {
      user: {
        memberId: api.store.loginedUser.mchUid,
        displayId: api.store.loginedUser.displayId,
        nickname: api.store.loginedUser.nickname,
        avatar: api.store.loginedUser.avatarUrl,
        mchLogoUrl: api.store.loginedUser.mchLogoUrl,
        pointUnit: api.store.loginedUser.config.pointName,
        point: api.store.loginedUser.pointCredit,
        pointDetailPageUrl: api.store.loginedUser.config.pointDetailPageUrl,
        enableLottery: api.store.loginedUser.enableLottery,
        kkbUser: api.store.loginedUser.kkbUser,
        kubaoLotteryLoginUrl: api.store.loginedUser.kubaoLotteryLoginUrl,
      },
      easyUser: store.loginedUser.easyUser,
      active: store.active,

    };
  },
  methods: {
    goToKubaoLottery() {
      this.$refs.kubaoLotteryPrompt.display();
    },
    gotoLottery() {
      var url = process.env.lotteryLoginUrl;
      location.href = url;
    },
  },
  mounted() {
    api.user.getPersonalInfo((user) => {
      this.user.point = user.pointCredit;
    });
  },
};
</script>

<style scoped lang="less">
body {
  background: #f2f2f2;
}
.display-id {
  position: fixed;
  width: 100%;
  text-align: center;
  bottom: 12vw;
  color: #ccc;
  font-size: 12px;
}
.wrap {
  border-radius: 0;
}
.menu-list {
  position: relative;
  z-index: 2;
  top: -12vw;

  //   &:after{
  //     content: '';
  //     background-image: url(../../assets/icon-setting-bg-0.png);
  //     background-size: contain;
  //     background-position: center;
  //     display: block;
  //     position: absolute;
  //     top: -22vw;
  //     right: 1vw;
  //     z-index: 1;
  //     width: 36.8vw;
  //     height: 29.8vw;
  //   }

  .first-menu-item {
    width: 94.67vw;
    height: 18.67vw;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 4.67vw;
    margin: 2.67vw auto;
    border-radius: 2.13vw;
    .menu-point {
      color: #ff3333;
      font-size: 4.8vw;
    }
    .point-title {
      color: #333;
      font-size: 3.47vw;
      margin-top: 2.5vw;
    }
  }

  .menu-center {
    width: 94.67vw;
    margin: 2.67vw auto;
    border-radius: 2.13vw;
    padding: 1.33vw 0;
    background: #fff;
    .wrap {
      width: 100%;
      align-items: center;
      //   border-radius: 0;
      font-size: 4vw;
      margin: 0 auto;
    }
  }
}

.menu-point {
  color: @themeColor;
}

.menu-btn {
  background: linear-gradient(to right, #fe0e31, #fe7f5e);
  color: #fff;
  border: none;
  line-height: 9.33vw;
  border-radius: 4.67vw;
  padding: 0 4.6vw;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  float: right;
  font-size: 4vw;
}

.top-wrap {
  height: 36vw;
  position: relative;
  z-index: 2;

  .avatar {
    width: 13.3vw;
    height: 13.3vw;
    background-position: center;
    background-size: cover;
    border-radius: 50%;
    position: absolute;
    top: 7.133vw;
    left: 6.133vw;
    z-index: 3;
  }

  .info {
    position: absolute;
    z-index: 3;
    left: 22.66vw;
    top: 8.133vw;

    .text {
      color: #fff;
      line-height: 13.3vw / 2;
    }

    .text-1 {
      font-size: 4.8vw;
    }
    .text-2 {
      font-size: 3.6vw;
      opacity: 0.6;
    }
  }

  .bg {
    background-image: url(../../assets/grzx_bg_img.png);
    background-position: top;
    background-size: 100% 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 40vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/Index.vue